import { ref } from "vue";

import type { ITransaction } from "@/utils/types";
import WebSocketClient from "@/libs/WebSocketClient";

let initialized = false;
let unsubscribeLatestTransactions: (() => void) | null = null;

const latestTransactions = ref<ITransaction[]>([]);

export function useLatestTransactions() {
  if (!initialized) {
    initialized = true;
    unsubscribeLatestTransactions = WebSocketClient.subscribeForTransactions(
      (payload: any) => {
        console.log("Latest transaction detected", { payload });

        // when latestTransaction is more than 50, remove first 20
        if (latestTransactions.value.length > 50) {
          latestTransactions.value = latestTransactions.value.slice(20);
        }
        latestTransactions.value.push({
          token: payload.token,
          ...payload.data,
        });
      }
    );
  }

  return {
    latestTransactions,
    unsubscribeLatestTransactions,
  };
}
